module.exports = __webpack_public_path__ + "static/media/dark-query-rules.cf8f12c7.svg";